import React from 'react';
import { NoResultsCard } from '@/components/Cards';
import { Trans } from '@lingui/react/macro';
import { Order, OrderGroup, BatchedChanges } from '@/types';
import OrderGroupListItem from './OrderGroupListItem';

type OrderListProps = {
    orders: OrderGroup[];
    defaultExpandedId?: number;
    onChange: (changes: BatchedChanges<Order>) => void;
};

const OrderGroupList: React.FC<OrderListProps> = ({ orders, onChange, defaultExpandedId, ...rest }) => {
    return (
        <>
            {orders.map((order) => (
                <OrderGroupListItem
                    onChange={onChange}
                    defaultExpandedId={defaultExpandedId}
                    key={order.id}
                    orderGroup={order}
                    {...rest}
                />
            ))}

            {orders.length === 0 && (
                <NoResultsCard>
                    <Trans>No orders</Trans>
                </NoResultsCard>
            )}
        </>
    );
};

export default OrderGroupList;